/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GenerateInstrumentLinkNotificationRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GenerateInstrumentLinkNotification.pb'
import {GenerateInstrumentLinkNotificationResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GenerateInstrumentLinkNotification.pb'


export const generateInstrumentLinkNotification = (request: GenerateInstrumentLinkNotificationRequest, options?: CashRequestOptions) => post<GenerateInstrumentLinkNotificationRequest, GenerateInstrumentLinkNotificationResponse>("/2.0/cash/generate-instrument-link-notification", request, {...options, rejectOnError: true })